const CHEQUES = 'finanzas/cheques'
const MOVIMIENTOS = 'finanzas/cheques/movimiento/'
const DEPOSITOS = 'caja/dte/depositos'
export {
    CHEQUES,
    MOVIMIENTOS,
    DEPOSITOS
}
